const sections = [
  {
    title: 'Member Directory & Profiles',
    desc: 'Every member gets a rich profile with contact info, membership history, event attendance, committee assignments, payment records, and engagement score. Search, filter, and export your entire directory instantly.',
    items: [
      { label: 'Sarah Chen — Board Member', status: 'Active', type: 'Professional' },
      { label: 'James Wilson — General', status: 'Active', type: 'Standard' },
      { label: 'Maria Garcia — Volunteer', status: 'Renewal Due', type: 'Standard' },
      { label: 'Robert Kim — New Applicant', status: 'Pending', type: 'Professional' },
    ],
  },
  {
    title: 'Event Management Dashboard',
    desc: 'From annual galas to weekly committee meetings, manage RSVPs, capacity, ticketing, check-ins, and post-event surveys all in one view. Automatic reminder emails keep attendance high.',
    items: [
      { label: 'Annual Gala Fundraiser', status: '156 / 200', type: 'Apr 28' },
      { label: 'Q2 Board Meeting', status: '12 / 15', type: 'Apr 22' },
      { label: 'New Member Orientation', status: '24 / 30', type: 'May 3' },
      { label: 'Summer Networking Mixer', status: '0 / 100', type: 'Jun 15' },
    ],
  },
];

export function ProductShowcase() {
  return (
    <section className="relative py-28 sm:py-32">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: 'linear-gradient(180deg, rgba(10,15,13,0) 0%, rgba(4,47,46,0.1) 50%, rgba(10,15,13,0) 100%)',
        }}
      />

      <div className="relative mx-auto max-w-6xl px-6">
        <div className="mb-16 text-center reveal">
          <span className="mb-4 inline-block rounded-full border border-ams-700/40 bg-ams-950/40 px-3 py-1 text-xs font-medium text-ams-400">
            See It In Action
          </span>
          <h2 className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Designed for How You Actually Work
          </h2>
          <p className="mx-auto max-w-2xl text-zinc-400">
            Clean, intuitive interfaces that your staff and volunteers can learn in minutes, not months.
          </p>
        </div>

        <div className="space-y-12">
          {sections.map((section, idx) => (
            <div
              key={section.title}
              className={`reveal grid items-center gap-8 lg:grid-cols-2 ${idx % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}
            >
              <div className={idx % 2 === 1 ? 'lg:order-2' : ''}>
                <h3 className="mb-3 text-xl font-bold">{section.title}</h3>
                <p className="text-sm leading-relaxed text-zinc-400">{section.desc}</p>
              </div>

              <div className={`mockup-window ${idx % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="mockup-titlebar">
                  <div className="mockup-dot" style={{ background: '#ef4444' }} />
                  <div className="mockup-dot" style={{ background: '#f59e0b' }} />
                  <div className="mockup-dot" style={{ background: '#22c55e' }} />
                  <span className="ml-2 text-xs text-zinc-500">{section.title}</span>
                </div>
                <div className="p-4 space-y-2">
                  {section.items.map((item) => (
                    <div
                      key={item.label}
                      className="flex items-center justify-between rounded-lg border border-ams-800/15 bg-ams-950/30 px-4 py-3"
                    >
                      <span className="text-sm text-zinc-300">{item.label}</span>
                      <div className="flex items-center gap-3">
                        <span className="text-xs text-zinc-500">{item.type}</span>
                        <span
                          className={`rounded-full px-2 py-0.5 text-[10px] font-medium ${
                            item.status === 'Active'
                              ? 'bg-emerald-500/15 text-emerald-400'
                              : item.status === 'Pending'
                                ? 'bg-amber-500/15 text-amber-400'
                                : item.status === 'Renewal Due'
                                  ? 'bg-red-500/15 text-red-400'
                                  : 'bg-ams-500/15 text-ams-400'
                          }`}
                        >
                          {item.status}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
